import React, { useState } from 'react'

const withState = WrappedComponent => {
  return props => {
    const {
      account: { preferences } // via GraphQL query
    } = props

    // setup form state
    const { newProjectNotifications, onlineOnly } = preferences

    const [form, setForm] = useState({
      newProjectNotifications: String(newProjectNotifications),
      onlineOnly: String(onlineOnly)
    })

    return (
      <WrappedComponent
        preferences={preferences}
        form={form}
        setForm={setForm}
        {...props}
      />
    )
  }
}

export default withState
